import {
  borderCss,
  boxShadowCss,
  mobileBorderCss,
  mobileBoxShadowCss,
} from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import styled, { css } from 'styled-components'

type BlogPostImageUiProps = BorderEntityInterface & {
  boxShadow?: string
  mobileBoxShadow?: string
}

const BlogPostImageUi = styled.img<BlogPostImageUiProps>`
  width: 100%;
  display: block;
  ${boxShadowCss}
  ${borderCss}
  ${p => p.theme.phone} {
    ${mobileBoxShadowCss}
    ${mobileBorderCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBoxShadowCss}
      ${mobileBorderCss}
    `}
`

export default BlogPostImageUi
